<!--suppress JSUnresolvedVariable -->
<template>
  <section id="company-profile" class="bg-white py-5">
    <div class="container">
      <h3 class="text-center text-primary font-weight-bold wow fadeInDown">
        公司
        <img :src="titleImgUrl" alt="logo" class="mx-2" width="50" />
        简介
      </h3>
      <div class="text-center  mb-4 text-secondary wow fadeInUp">
        —— {{ sectionSubTitle }} ——
      </div>
      <div class="row text-secondary mb-5 px-3">
        <div
          class="col-lg-7 order-2 order-lg-1"
          style="font-size: 16px;"
          v-html="companyIntroduction"
        ></div>
        <div class="col-lg-5 order-1 order-lg-2 mb-3 mb-lg-0">
          <img :src="companyCover" alt="图片" class="img-fluid img-thumbnail" />
        </div>
      </div>
      <div class="text-center mt-4 wow fadeInDown">
        <router-link
          to="/toCompanyDetail"
          class="text-primary text-decoration-none font-weight-bold find-more"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          查看更多
        </router-link>
      </div>
    </div>
  </section>
</template>

<!--suppress ES6CheckImport -->
<script>
import { WOW } from "wowjs";

export default {
  name: "CompanyProfile",
  data() {
    return {
      titleImgUrl: "",
      sectionSubTitle: "",
      moreImgUrl: "",
      companyCover: "",
      companyIntroduction: ""
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.getNavById();
    this.getCompanyInfo();
  },
  methods: {
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 2)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.titleImgUrl = resp.data.data.titleImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getCompanyInfo() {
      this.axios
        .get("/companyInformation/getCompanyInfo/")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.companyCover = resp.data.data.companyCover;
            this.companyIntroduction = resp.data.data.companyIntroduction;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
#company-profile {
  .container {
    .find-more {
      font-size: 18px;
    }
    @media only screen and (min-width: 576px) {
      .find-more {
        font-size: 14px;
      }
    }
  }
}
</style>
